<template>
  <div class="container">
    <!-- Show Loading Spinner -->
    <div v-if="loading" class="loading-container">
      <i class="fa fa-spinner fa-spin"></i>
      <span>Loading...</span>
    </div>

    <div v-else>
      <!-- Promotion Information -->
      <div class="promo-section">
        <div class="promo-section-header">
          <h4 class="promo-section-title">Promotion Information</h4>
          <span class="extra-data">
              Priority No: {{ promotionDetails.priority }}
            </span>
        </div>

        <div class="promo-details-box full-width promo-name-status">
          <label>Promotion Name</label>
          <div class="name-status-row">
            <p>{{ promotionDetails.promotion_name }}</p>
            <span
                class="status-badge"
                :class="{
                    pending: promotionDetails.status === '0',
                    active: promotionDetails.status === '1',
                    rejected: promotionDetails.status === '2',
                    deactivated: promotionDetails.status === '3'
                  }"
            >
                  <span class="status-dot"></span>
                  {{
                promotionDetails.status === '0'
                    ? 'Pending'
                    : promotionDetails.status === '1'
                        ? 'Active'
                        : promotionDetails.status === '2'
                            ? 'Rejected'
                            : 'Deactivated'
              }}
                </span>
          </div>
        </div>
        <div class="promo-details-row">
          <div class="promo-details-box">
            <label>Promo Code</label>
            <p>{{ promotionDetails.promotion_code }}</p>
          </div>
          <div class="promo-details-box">
            <label>Promotion Type</label>
            <p>{{ promotionDetails.promotion_type }}</p>
          </div>
        </div>
        <div class="promo-details-row">
          <div class="promo-details-box">
            <label>Start Date</label>
            <p>{{ promotionDetails.start_date }}</p>
          </div>
          <div class="promo-details-box">
            <label>End Date</label>
            <p>{{ promotionDetails.end_date }}</p>
          </div>
        </div>
        <div class="promo-details-row">
          <div class="promo-details-box">
            <label>Promotion Created By</label>
            <p>{{ promotionDetails.create_by }}</p>
          </div>
          <div class="promo-details-box">
            <label>Created Date & Time</label>
            <p>{{ formatDateTime(promotionDetails.created_at) }}</p>
          </div>
        </div>
      </div>

      <!-- Promotion Item Setup -->
      <div class="promo-section">
        <h4 class="promo-section-title">Promotion Item Setup</h4>

        <!-- Free Issue Promotion Type -->
        <div v-if="promotionDetails.promotion_type === 'Free Issue'">
          <div class="promo-details-row">
            <div class="promo-details-box">
              <label>Buy Item</label>
              <p>{{ promotionDetails.get_item_name }}</p>
            </div>
            <div class="promo-details-box">
              <label>Buy Qty</label>
              <p>{{ promotionDetails.get_qty }}</p>
            </div>
          </div>

          <div class="promo-details-row">
            <div class="promo-details-box">
              <label>Free Item</label>
              <p>{{ promotionDetails.free_item_name }}</p>
            </div>
            <div class="promo-details-box">
              <label>Free Qty</label>
              <p>{{ promotionDetails.free_qty }}</p>
            </div>
          </div>

          <div class="promo-details-box full-width">
            <label>Maximum Applicable Free Qty</label>
            <p>{{ promotionDetails.max_discount_qty }}</p>
          </div>
        </div>

        <!-- Discount Promotion Type -->
        <div v-if="promotionDetails.promotion_type === 'Discount'">
          <div class="promo-details-row">
            <div class="promo-details-box">
              <label>Buy Item</label>
              <p>{{ promotionDetails.discount_item_name }}</p>
            </div>
          </div>

          <div class="promo-details-row">
            <div class="promo-details-box">
              <label>Discount Type</label>
              <p>{{ promotionDetails.promotion_type }}</p>
            </div>
            <div class="promo-details-box">
              <label>Discount</label>
              <p>
          <span v-if="promotionDetails.discount_type.toString().toLowerCase() === 'percentage'">
            {{ promotionDetails.discount_amount }}%
          </span>
                <span v-else-if="promotionDetails.discount_type.toString().toLowerCase() === 'value'">
            Rs.{{ promotionDetails.discount_amount }}
          </span>
              </p>
            </div>
          </div>

          <div class="promo-details-row">
            <div class="promo-details-box">
              <label>Minimum Required Buy Qty</label>
              <p>{{ promotionDetails.min_qty_discount }}</p>
            </div>
            <div class="promo-details-box">
              <label>Maximum Applicable Free Qty</label>
              <p>{{ promotionDetails.max_qty_discount }}</p>
            </div>
          </div>
        </div>

        <!-- Competitor Price Discount Promotion Type -->
        <div v-if="promotionDetails.promotion_type === 'Competitor Price Discount'">
          <div class="promo-details-row">
            <div class="promo-details-box">
              <label>Buy Item</label>
              <p>{{ promotionDetails.discount_item_name }}</p>
            </div>
          </div>

          <div class="promo-details-row">
            <div class="promo-details-box">
              <label>Discount Type</label>
              <p>{{ promotionDetails.promotion_type }}</p>
            </div>
            <div class="promo-details-box">
              <label>Discount</label>
              <p>
          <span v-if="promotionDetails.discount_type.toString().toLowerCase() === 'percentage'">
            {{ promotionDetails.discount_amount }}%
          </span>
                <span v-else-if="promotionDetails.discount_type.toString().toLowerCase() === 'value'">
            Rs.{{ promotionDetails.discount_amount }}
          </span>
              </p>
            </div>
          </div>
        </div>

        <!-- Trust Promotion Type -->
        <div v-if="promotionDetails.promotion_type === 'Trust'">
          <div class="promo-details-row">
            <div class="promo-details-box">
              <label>Buy Item</label>
              <p>{{ promotionDetails.discount_item_name }}</p>
            </div>
          </div>

          <div class="promo-details-row">
            <div class="promo-details-box">
              <label>Discount Type</label>
              <p>Quantity</p>
            </div>
            <div class="promo-details-box">
              <label>Maximum quantity</label>
              <p>{{ promotionDetails.discount_amount }}</p>
            </div>
          </div>
        </div>
      </div>

      <!-- Promotion Applicable Dealers -->
      <div class="dealer-selection-section promo-section">
        <div class="dealer-header">
          <h4 class="promo-section-title">Promotion Applicable Dealers</h4>
          <span class="extra-data">
              No of Dealers: {{ dealerCount }}
          </span>
        </div>

        <!-- Dealer Search -->
        <div class="form-row search-container" style="margin-top: 15px;">
          <input
              type="text"
              v-model="dealerSearch"
              placeholder="Search dealers by name..."
              class="search-box"
          />
        </div>

        <!-- Tab Buttons -->
        <div class="dealer-tabs">
          <button type="button" :class="{ active: activeTab === 'all' }" @click="activeTab = 'all'">All</button>
          <button type="button" :class="{ active: activeTab === 'route' }" @click="activeTab = 'route'">Filter by Route</button>
          <button type="button" :class="{ active: activeTab === 'group' }" @click="activeTab = 'group'">Filter by Group</button>
          <button type="button" :class="{ active: activeTab === 'category' }" @click="activeTab = 'category'">Filter by Category</button>
        </div>

        <!-- Tab Content: All -->
        <div v-if="activeTab === 'all'" class="tab-content">
          <div class="dealer-cards">
             <div v-for="dealer in filteredAllDealers" :key="dealer.profileId" class="dealer-card">
                 <strong>{{ dealer.businessName }}</strong><br>
                 <small>Address: {{ dealer.address }}</small><br>
             </div>
          </div>
        </div>

        <!-- Tab Content: Filter by Route -->
        <div v-if="activeTab === 'route'" class="tab-content">
           <div v-for="(dealersInRoute, route) in dealersByRoute" :key="route" class="dealer-group">
              <div class="group-header" @click="toggleCollapse('route', route)">
                 <span>
                   {{ route || 'Unassigned' }}
                   <small style="font-weight: normal; margin-left: 10px; color: #555;">
                     Count: {{ dealersInRoute.length }}
                   </small>
                 </span>
                 <div class="accordion-actions">
                   <i :class="getCollapseIcon('route', route)"></i>
                 </div>
              </div>
              <div class="group-body" v-show="!isCollapsed('route', route)">
                 <div class="dealer-cards">
                   <div v-for="dealer in dealersInRoute" :key="dealer.profileId" class="dealer-card">
                       <strong>{{ dealer.businessName }}</strong><br>
                       <small>Address: {{ dealer.address }}</small><br>
                   </div>
                 </div>
              </div>
           </div>
        </div>

        <!-- Tab Content: Filter by Group -->
        <div v-if="activeTab === 'group'" class="tab-content">
           <div v-for="(dealersInGroup, group) in dealersByGroup" :key="group" class="dealer-group">
              <div class="group-header" @click="toggleCollapse('group', group)">
                 <span>
                   {{ group || 'Unassigned' }}
                   <small style="font-weight: normal; margin-left: 10px; color: #555;">
                     Count: {{ dealersInGroup.length }}
                   </small>
                 </span>
                 <div class="accordion-actions">
                   <i :class="getCollapseIcon('group', group)"></i>
                 </div>
              </div>
              <div class="group-body" v-show="!isCollapsed('group', group)">
                 <div class="dealer-cards">
                   <div v-for="dealer in dealersInGroup" :key="dealer.profileId" class="dealer-card">
                       <strong>{{ dealer.businessName }}</strong><br>
                       <small>Address: {{ dealer.address }}</small><br>
                   </div>
                 </div>
              </div>
           </div>
        </div>

        <!-- Tab Content: Filter by Category -->
        <div v-if="activeTab === 'category'" class="tab-content">
           <div v-for="(dealersInCategory, category) in dealersByCategory" :key="category" class="dealer-group">
              <div class="group-header" @click="toggleCollapse('category', category)">
                 <span>
                   {{ category || 'Unassigned' }}
                   <small style="font-weight: normal; margin-left: 10px; color: #555;">
                     Count: {{ dealersInCategory.length }}
                   </small>
                 </span>
                 <div class="accordion-actions">
                   <i :class="getCollapseIcon('category', category)"></i>
                 </div>
              </div>
              <div class="group-body" v-show="!isCollapsed('category', category)">
                 <div class="dealer-cards">
                   <div v-for="dealer in dealersInCategory" :key="dealer.profileId" class="dealer-card">
                       <strong>{{ dealer.businessName }}</strong><br>
                       <small>Address: {{ dealer.address }}</small><br>
                   </div>
                 </div>
              </div>
           </div>
        </div>
      </div>

      <!-- Promotion Approved Details -->
      <div v-if="promotionDetails.status === '1'" class="promo-section" style="margin-top: 30px;">
        <h4 class="promo-section-title"> Promotion Approved Details </h4>
        <div class="promo-details-row">
          <div class="promo-details-box">
            <label>Approved By</label>
            <p>{{ promotionDetails.reviewed_by }}</p>
          </div>
          <div class="promo-details-box">
            <label>Approved Date & Time</label>
            <p>{{ formatDateTime(promotionDetails.reviewed_at) }}</p>
          </div>
        </div>

        <div class="promo-details-box full-width">
          <label>Approval Remark</label>
          <p>{{ promotionDetails.review_remark }}</p>
        </div>
      </div>

      <!-- Promotion Rejected Details -->
      <div v-if="promotionDetails.status === '2'" class="promo-section" style="margin-top: 30px;">
        <h4 class="promo-section-title">Promotion Rejected Details</h4>

        <div class="promo-details-row">
          <div class="promo-details-box">
            <label>Rejected By</label>
            <p>{{ promotionDetails.reviewed_by }}</p>
          </div>
          <div class="promo-details-box">
            <label>Rejected Date & Time</label>
            <p>{{ formatDateTime(promotionDetails.reviewed_at) }}</p>
          </div>
        </div>

        <div class="promo-details-box full-width">
          <label>Rejection Remark</label>
          <p>{{ promotionDetails.review_remark }}</p>
        </div>
      </div>

      <!-- Action Buttons -->
      <div class="form-actions">
        <button v-if="!loading && promotionDetails.status === '3'" class="activate-promotion" @click="openActivateDialog">Activate Promotion</button>
        <button v-if="!loading && promotionDetails.status === '1'" class="deactivate-promotion" @click="openDeactivateDialog">Deactivate Promotion</button>
        <button class="edit-promotion" v-if="!isApplied" @click="navigateToEdit(promoId)">Edit Promotion</button>
      </div>
    </div>

    <!-- Promotion Activate Dialog Box -->
    <promotionDeactivate
        v-if="showDeactivateDialog"
        :promoId="promoId"
        @close="showDeactivateDialog = false"
        @redirect="redirectToMain()"
    />

    <!-- Promotion Deactivate Dialog Box -->
    <promotionActivate
        v-if="showActivateDialog"
        :promoId="promoId"
        :start_date="promotionDetails.start_date"
        :end_date="promotionDetails.end_date"
        @close="showActivateDialog = false"
        @redirect="redirectToMain()"
    />
  </div>
</template>

<script>
import { viewPromotionDetails } from "@/services/dataService";
import { useToast } from "vue-toastification";
import promotionDeactivate from "@/pages/Modal/promotions/promotion/promotionDeactivate.vue";
import promotionActivate from "@/pages/Modal/promotions/promotion/promotionActivate.vue";

export default {
  components: {
    promotionDeactivate,
    promotionActivate
  },

  props: {
    promoId: {
      type: String,
      required: true
    },
    isApplied: {
      type: Boolean,
      default: false
    }
  },

  data() {
    return {
      token: localStorage.getItem('token_set'), //Get the API access token from the local storage
      loading: false,
      promotionDetails: {},
      promotionEligibleDetails: [],
      showActivateDialog: false,
      showDeactivateDialog: false,
      activeTab: 'all',
      collapseState: {
        route: {},
        group: {},
        category: {}
      },
      dealerSearch: ""
    }
  },

  mounted() {
    this.viewPromotionInfo();
  },

  computed: {
    //Calculate the promotion applicable dealers count
    dealerCount() {
      const count = this.promotionEligibleDetails.length;
      // Format with commas
      return count.toLocaleString();
    },

    filteredAllDealers() {
      if (!this.dealerSearch) return this.promotionEligibleDetails;
      const searchLower = this.dealerSearch.toLowerCase();
      return this.promotionEligibleDetails.filter(d => {
        const name = d.businessName ? d.businessName.toLowerCase() : "";
        return name.includes(searchLower);
      });
    },
    dealersByRoute() {
      return this.filteredAllDealers.reduce((acc, dealer) => {
        const key = dealer.route || 'Unassigned';
        if (!acc[key]) acc[key] = [];
        acc[key].push(dealer);
        return acc;
      }, {});
    },
    dealersByGroup() {
      return this.filteredAllDealers.reduce((acc, dealer) => {
        const key = dealer.dealer_group || 'Unassigned';
        if (!acc[key]) acc[key] = [];
        acc[key].push(dealer);
        return acc;
      }, {});
    },
    dealersByCategory() {
      return this.filteredAllDealers.reduce((acc, dealer) => {
        const key = dealer.dealer_category || 'Unassigned';
        if (!acc[key]) acc[key] = [];
        acc[key].push(dealer);
        return acc;
      }, {});
    }
  },

  setup() {
    const toast = useToast();
    return { toast };
  },

  methods: {
    toggleCollapse(type, key) {
      this.collapseState[type][key] = !this.collapseState[type][key];
    },
    isCollapsed(type, key) {
      return !!this.collapseState[type][key];
    },
    getCollapseIcon(type, key) {
      return this.isCollapsed(type, key) ? 'fa-solid fa-chevron-down' : 'fa-solid fa-chevron-up';
    },

    //Promotion created date formatting
    formatDateTime(datetime) {
      if (!datetime) return "";

      const dateObj = new Date(datetime);

      const datePart = dateObj.toISOString().split("T")[0]; // YYYY-MM-DD

      const options = {
        hour: "numeric",
        minute: "numeric",
        hour12: true,
      };
      const timePart = dateObj.toLocaleTimeString("en-US", options);

      return `${datePart}, ${timePart}`;
    },

    //Call API to fetch promotion data
    async viewPromotionInfo() {
      try {
        //Set Loading Status
        this.loading = true;

        //Reset Arrays and List to Map data from API response
        this.promotionDetails = {};
        this.promotionEligibleDetails = [];

        //Call API to fetch promotion details
        const response = await viewPromotionDetails(this.promoId, this.token);

        if (response.data.status === true) {
          this.promotionDetails = response.data.promotion;
          this.promotionEligibleDetails = response.data.customers || [];
        } else {
          this.toast.error(response.data.message);
        }
      } catch (e) {
        this.toast.error("Failed to fetch promotion details");
      } finally {
        this.loading = false;
      }
    },

    navigateToEdit(id) {
      this.$router.push({
        path: '/edit-promotion',
        query: { promoId: id }   // pass as query param
      });
    },

    //when activate clicked
    openActivateDialog() {
      this.showActivateDialog = true;
    },

    //when deactivate clicked
    openDeactivateDialog() {
      this.showDeactivateDialog = true;
    },

    //Redirect to main screen and refresh it
    redirectToMain() {
      this.$router.push('/promotions');
    }
  }
};
</script>

<style scoped>
/* Ensure the body and html take the full height of the page */
html, body {
  height: 100%;
  margin: 0;
  padding: 0;
  background-color: #f0f0f0; /* Background color for the page */
}

/* Container for the entire section */
.container {
  background-color: #ffffff;
  padding: 20px 15px; /* reduce side padding for smaller devices */
  margin: 10px auto;
  width: 100%; /* full width of device */
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
  border-radius: 8px;
  box-sizing: border-box; /* include padding in width */
  max-width: 100%; /* prevent any fixed max-width */
}

/* Centered Loading Component */
.loading-container {
  display: flex;
  flex-direction: column; /* separate rows */
  justify-content: center;
  align-items: center;
  height: 300px; /* Adjust height to fit modal body if needed */
  font-size: 16px;
  color: #007bff;
  gap: 10px; /* spacing between spinner and text */
}

/* Promo section wrapper */
.promo-section {
  margin-bottom: 30px;
}

/* Promo section rows (with extra margin) */
.promo-section .promo-details-row {
  display: flex;
  gap: 10px;
  margin-bottom: 10px;
}

/* Promo section title */
.promo-section-title {
  font-size: 14px;
  font-weight: bold;
  margin-bottom: 8px;
  color: #333;
}

/* Promo details row (horizontal boxes) */
.promo-details-row {
  display: flex;
  gap: 10px;
}

/* Promo details box (single field) */
.promo-details-box {
  flex: 1;
  background-color: #f6f6f6;
  border-radius: 6px;
  padding: 8px 12px;
  border: 1px solid #ddd;
}

/* Add spacing below full-width boxes */
.promo-details-box.full-width {
  margin-bottom: 10px;
}

/* Promo details box label */
.promo-details-box label {
  display: block;
  font-weight: bold;
  font-size: 12px;
  margin-bottom: 4px;
  color: #333;
}

/* Promo details box value */
.promo-details-box p {
  font-size: 14px;
  margin: 0;
  color: #000;
  word-wrap: break-word;      /* Break long words if necessary */
  word-break: break-word;     /* Break long words if necessary */
  white-space: normal;        /* Allow wrapping to next line */
}

/* Full width special case */
.full-width {
  width: 100%;
}

/* Container row for name + status */
.name-status-row {
  display: flex;
  align-items: center;
  justify-content: space-between;
}

/* Status badge */
.status-badge {
  display: flex;
  align-items: center;
  font-size: 13px;
  font-weight: bold;
  padding: 2px 8px;
  border-radius: 12px;
  gap: 6px;
}

/* Status dot */
.status-dot {
  width: 8px;
  height: 8px;
  border-radius: 50%;
  display: inline-block;
}

/* Pending = Amber */
.status-badge.pending {
  color: #8a6d3b;
  background-color: #fff3cd;
}
.status-badge.pending .status-dot {
  background-color: #ffb300; /* amber */
}

/* Active = Green */
.status-badge.active {
  color: #155724;
  background-color: #d4edda;
}
.status-badge.active .status-dot {
  background-color: #28a745;
}

/* Rejected = Red */
.status-badge.rejected {
  color: #721c24;
  background-color: #f8d7da;
}
.status-badge.rejected .status-dot {
  background-color: #dc3545;
}

/* Deactivated = Black */
.status-badge.deactivated {
  color: #000;
  background-color: #ccc;
}
.status-badge.deactivated .status-dot {
  background-color: #000;
}

/* Dealer list container */
.dealer-item {
  display: flex;
  align-items: center;       /* Vertically center icon and text */
  gap: 8px;                  /* Space between icon and text */
}

/* Dealer list container - Icon */
.dealer-item i {
  font-size: 16px;           /* Icon size */
  color: grey;            /* Optional icon color */
}

/* Dealer list container - Business Name */
.dealer-item p {
  margin: 0;
  word-break: break-word;    /* Wrap long dealer names */
}

/* Dealer box style */
.dealer-list .promo-details-box {
  padding: 10px 12px;
  font-size: 14px;
}

/* Section header with title + count */
.promo-section-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

/* Extra Data Style */
.extra-data {
  font-size: 13px;
  color: grey;
}

/* Dealer Group inside Tabs */
.dealer-group {
  border: 1px solid #ddd;
  border-radius: 6px;
  margin-bottom: 10px;
  background: #f9f9f9;
}

/* Distributor header */
.group-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  background: #eee;
  padding: 10px 15px;
  font-weight: bold;
  cursor: pointer;
}

.group-header span {
  font-size: 14px;
  color: #000;
}

/* Collapse button */
.collapse-btn {
  border: none;
  background: none;
  cursor: pointer;
  font-size: 14px;
  color: #555;
}

/* Dealers list inside group */
.group-body {
  padding: 15px;
}

/* Dealer count in header */
.dealer-count {
  font-size: 12px;
  color: grey;
  margin-left: 5px;
}

/* Dealer Selection Section */
.dealer-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
}
/* Search Box */
.search-container {
  display: flex;
  gap: 15px;
  align-items: center;
}
.search-box {
  flex: 1;
  padding: 8px 12px;
  border: 1px solid #ccc;
  border-radius: 6px;
  outline: none;
}
.search-box:focus {
  border-color: #0d6efd;
}
/* Dealer Tabs */
.dealer-tabs {
  display: flex;
  gap: 10px;
  margin-top: 15px;
}
.dealer-tabs button {
  padding: 8px 20px;
  border: 1px solid #dee2e6;
  background: #f8f9fa;
  cursor: pointer;
  font-weight: 500;
  color: #555;
  border-radius: 25px;
  transition: all 0.2s ease;
}
.dealer-tabs button.active {
  background: #0d6efd;
  border-color: #0d6efd;
  color: white;
}
.dealer-tabs button:hover:not(.active) {
  background: #e9ecef;
}
/* Tab Content */
.tab-content {
  margin-top: 20px;
  margin-bottom: 20px;
  max-height: 400px;
  overflow-y: auto;
}
/* Dealer Cards Container */
.dealer-cards {
  display: flex;
  flex-wrap: wrap;
  gap: 15px;
}
/* Dealer Card */
.dealer-card {
  width: calc(33.333% - 10px);
  min-width: 200px;
  border: 1px solid #ccc;
  border-radius: 8px;
  padding: 12px;
  cursor: default;
  background: #fff;
  position: relative;
  transition: all 0.2s ease-in-out;
}
.dealer-card:hover {
  box-shadow: 0 4px 8px rgba(0,0,0,0.1);
}
.accordion-actions {
  display: flex;
  align-items: center;
  gap: 15px;
}

/* Promotion Creation Form - Form Actions */
.form-actions {
  margin-top: 40px;
  padding-top: 20px;
  display: flex;
  justify-content: space-between;
  gap: 10px;
}

/* Promotion Creation Form - Form Actions Buttons */
.form-actions button {
  padding: 8px 16px;
  border-radius: 6px;
  border: none;
  cursor: pointer;
  color: #fff;
}

/* Promotion Creation Form - Form Actions Button - Activate */
.form-actions button.activate-promotion {
  background-color: #155724;
}

/* Promotion Creation Form - Form Actions Button - Deactivate */
.form-actions button.deactivate-promotion {
  background-color: #E62727;
}

/* Promotion Creation Form - Form Actions Button - Edit Promotion */
.form-actions button.edit-promotion {
  background-color: #0d6efd;
}

.dealer-selection-section {
  margin-bottom: 50px !important;
}
</style>